import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ClusterUserUpdateDto, ClusterUsersService } from 'src/api/v2';
import { MY_CLUSTER_USER_KEY } from 'src/constants/hook-keys';
import { useCluster } from 'src/features/cluster';

export function useCurrentClusterUser(isAadUser?: boolean) {
  const [service] = useState(new ClusterUsersService());

  const { cluster } = useCluster();

  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: (record: ClusterUserUpdateDto) => service.update(data?.id as string, record),
    onSuccess() {
      queryClient.invalidateQueries([MY_CLUSTER_USER_KEY]);
    },
  });

  const { data, ...rest } = useQuery({
    queryKey: [MY_CLUSTER_USER_KEY],
    queryFn: () => service.getCurrentClusterUser(),
    enabled: !!cluster && !isAadUser,
    refetchOnMount: true,
  });

  return {
    user: data,
    ...rest,

    mutations: {
      update: updateMutation,
    },
  };
}
